// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"8d856d1e","797":"76b928d8","840":"e9206a17","952":"1ad73f15"}[chunkId] + ".chunk.css";
};